import { ResponseType } from '@app/shared/enums';
import { AclItemApiModel } from '../../AclItemApiModel';

export class WorkflowStepApiModel {
  public Id: number;
  public FormId: number;
  public Name: string;
  public RestrictByLocation: boolean;
  public RestrictByShift: boolean;
  public RequireWorkflowComment: boolean;
  public Acl: AclItemApiModel[];
  public ResponseType: ResponseType;
  public NotifyByEmail: boolean;
  public RequireNextUserSelection: boolean;

  public deserialize(data): WorkflowStepApiModel {
    Object.assign(this, data);

    this.Acl = this.Acl.map((x) => new AclItemApiModel().deserialize(x));

    return this;
  }
}
